import { render, staticRenderFns } from "./mediaPublishPostUpload.vue?vue&type=template&id=4d54e936&scoped=true&"
import script from "./mediaPublishPostUpload.vue?vue&type=script&lang=js&"
export * from "./mediaPublishPostUpload.vue?vue&type=script&lang=js&"
import style0 from "./mediaPublishPostUpload.vue?vue&type=style&index=0&id=4d54e936&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d54e936",
  null
  
)

component.options.__file = "mediaPublishPostUpload.vue"
export default component.exports